<!-- 统一登录临时页面 -->
<template>
  <div />
</template>
<script>
import md5 from 'js-md5'
import Vue from 'vue'
import { Toast } from 'vant'
Vue.prototype.$md5 = md5

export default {
  name: 'CasLogin',
  mounted() {
    this.handleCasLogin()
  },
  methods: {
    handleCasLogin() {
      console.log('进入单点登录------------')
      const token = this.$route.query.token
      const idserial = this.$route.query.idserial
      // const entrySource = this.$route.query.entrySource
      // const jsonData = this.$route.query.jsonData

      if (token === undefined || token === '') {
        Toast.fail('传入参数无效！')
        console.log('token获取失败')
        this.$router.push({ path: this.redirect || '/login' })
        return false
      }
      // 微信浏览器单点登录 参数为空
      // if (entrySource !== null && entrySource !== '' && entrySource !== undefined && entrySource === 'WECHAT') {
      //   if (JSON.parse(jsonData).appid === undefined || JSON.parse(jsonData).appid === '' ||
      // JSON.parse(jsonData).openid === undefined || JSON.parse(jsonData).openid === '' ||
      // JSON.parse(jsonData).subappid === undefined || JSON.parse(jsonData).subappid === '' ||
      // JSON.parse(jsonData).appid === null || JSON.parse(jsonData).openid === null || JSON.parse(jsonData).subappid === null
      //   ) {
      //     Toast.fail('传入参数无效！')
      //     console.log('jsapi支付必须参数获取失败')
      //     this.$router.push({ path: this.redirect || '/login' })
      //     return false
      //   } else {
      //     window.localStorage.setItem('enterSource', 'wechat') // wechat
      //     window.localStorage.setItem('openId', JSON.parse(jsonData).openid)
      //     window.localStorage.setItem('appId', JSON.parse(jsonData).appid)
      //     window.localStorage.setItem('subAppId', JSON.parse(jsonData).subappid)
      //   }
      // }
      var params = { token: token, idserial: idserial }
      this.$store.dispatch('user/casLogin', params).then(() => {
        this.$router.push({ path: this.redirect || '/home' })
      })
      // this.$router.push({
      //   name: '/casLog',
      //   query: {
      //     token: this.$route.params.token,
      //     sign: this.$route.params.sign
      //   }
      // })
    }
  }
}
</script>
